import { Component, OnInit, signal, computed } from '@angular/core';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { SharedDataService } from '../../services/componentsServices/shared-data.service';
import { Sat, Region, Commodity, ProjectFilterModel,InputsAndValuesModel,Filter } from '../../models/store/filter.model'; // Importa las interfaces
import { Project } from '../../models/store/project'; // Importa las interfaces
import {ModelSelectionBarService} from '../../../shared/services/componentsServices/modelSelectionBar.service';
import { DropdownsDataResponse } from '../../models/store/filter.model';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { CommonModule } from '@angular/common';
import { PermissionService } from '../../services/security/permission.service';

@Component({
    selector: 'app-model-selection-bar',
    imports: [
    SelectModule,
        FormsModule,
        CommonModule,
        FontAwesomeModule
    ],
    templateUrl: './model-selection-bar.component.html',
    styleUrls: ['./model-selection-bar.component.scss']
})
export class ModelSelectionBarComponent implements OnInit {

  sats: Filter[] = [];
  regions: Filter[] = [];
  commodities: Filter[] = [];
  projects: Project[] = [];
  InputsAndValuesModel: InputsAndValuesModel[] = [];
  allProjects: Project[] = [];
  selectedSAT: number | null = null;
  selectedRegion: number | null = null;
  selectedCommodity: number | null = null;
  selectedProject: Project | null = null;
  faSpinner: IconDefinition = faSpinner;
  isLoading = signal(true);
  isDropdownDisabled = signal(true);

  canViewModelPredictions = computed(() => this.permissionService.can('modelPredictions:view'));
  disableFilters = computed(() => !this.canViewModelPredictions());

  constructor(
    private SharedDataService:SharedDataService,
    private ModelSelectionBarService:ModelSelectionBarService,
    private permissionService: PermissionService
  ) { }

  ngOnInit(): void {
    // this.loadSats();
    // this.loadRegions();
    // this.loadCommodities();
    // this.loadProjects(); 

    // this.getDropdownsData();
  this.loadDropdowns();
  }

  getDropdownsData(): void {
    let dropdowndData= this.SharedDataService.dropdowsnsData;
    if(dropdowndData) {
      this.mapResults(dropdowndData);
  this.SharedDataService.setDropdownsLoading(false);
    }
  }

  onFilterChange(): void {
  if (this.disableFilters()) { return; }
  this.selectedProject = null;
  this.onProjectSelect(0);
    if (this.selectedSAT && this.selectedRegion && this.selectedCommodity) {
      this.filterProjects();
    }
  }

  loadSats(): void {
    this.ModelSelectionBarService.getSats().subscribe((response) => {
      this.sats = response.filters;
    });
  }
  
  loadRegions(): void {
    this.ModelSelectionBarService.getRegions().subscribe((response) => {

      this.regions = response.filters;
    });
  }
  
  loadCommodities(): void {
    this.ModelSelectionBarService.getCommodities().subscribe((response) => {
      this.commodities = response.filters;
    });
  }

  loadProjects(): void {
    this.ModelSelectionBarService.getAllProjects().subscribe((response) => {
      this.projects = response.projects;
      this.allProjects = [...this.projects];
    });
  }

  loadDropdowns(): void {
    // Set global dropdowns loading
    this.SharedDataService.setDropdownsLoading(true);
    this.ModelSelectionBarService.getDropdownsData().subscribe({
      next: (response) => {
        this.SharedDataService.dropdowsnsData = response;
        this.mapResults(response);
        this.isLoading.set(false);
        this.SharedDataService.setDropdownsLoading(false);
      },
      error: () => {
        this.isLoading.set(false);
        this.SharedDataService.setDropdownsLoading(false);
      }
    });
  }

  mapResults(response: DropdownsDataResponse){
    this.sats = response.sats.map(sat => ({ id: sat.id, name: sat.name, isActive: false }));
    this.regions = response.regions.map(region => ({ id: region.id, name: region.name, isActive: false }));
    this.commodities = response.commodities.map(commodity => ({ id: commodity.id, name: commodity.name, isActive: false }));
    this.projects = response.projects;
    // Keep a full copy for filtering logic elsewhere in the component
  this.allProjects = [...this.projects];
  }

  //MT: this is not being used
  // loadInputsAndValues(): void {
  //   const filterRequest: ProjectFilterModel = {
  //     satId: this.selectedSAT || 0, 
  //     regionId: this.selectedRegion || 0,
  //     commodityId: this.selectedCommodity || 0,
  //     projectId: 1, 
  //   };

  //   this.ModelSelectionBarService.GetInputsAndValues(filterRequest).subscribe(
  //     (response) => {
  
  //       if (response.results && response.results.length > 0) {
  //         this.SharedDataService.updateData(response.results);
  //       }
  //     }
  //   );
  // }

  filterProjects(): void {
    this.selectedProject = null;
  
    if (!this.selectedSAT && !this.selectedRegion && !this.selectedCommodity) {
      this.projects = [...this.allProjects]; // Restaura la lista completa
      return;
    }
  
    this.projects = this.allProjects.filter(project => {
      const matchesSAT = this.selectedSAT ? project.satId === this.selectedSAT : true;
      const matchesRegion = this.selectedRegion ? project.regionId === this.selectedRegion : true;
      const matchesCommodity = this.selectedCommodity ? project.commoditieID === this.selectedCommodity : true;
  
      return matchesSAT && matchesRegion && matchesCommodity;
    });
  }
  
  setProjectName(selectedProject: ProjectFilterModel){
    let projectName = this.projects.find(project => project.id === selectedProject.projectId);
    this.SharedDataService.setProject(projectName ? projectName.shortName : '');
  }
  //TODO: Use this.SharedDataService.setProject() with the name of the project. To do this, fetch the list of projects and find the one that matches the id of the currentProject.
  onProjectSelect(event: any): void {

  if (this.disableFilters()) { return; }
  let selectedFilter: ProjectFilterModel = {
      commodityId: this.selectedCommodity ? this.selectedCommodity : 0,
      regionId: this.selectedRegion ? this.selectedRegion: 0,
      satId: this.selectedSAT ? this.selectedSAT: 0,
      projectId: event.value ? event.value: 0,
    };
    this.SharedDataService.setNavBarFilters(selectedFilter)
    this.setProjectName(selectedFilter);

    // const selectedId = event.value;
    // this.selectedProject = this.projects.find(project => project.id === selectedId) || null;
    // if (this.selectedProject && this.selectedProject.shortName) {
    //     this.SharedDataService.setProject(this.selectedProject.shortName);
    // } else {
    //     console.error('Selected project or shortName is undefined');
    // }
    
    // this.loadInputsAndValues();
}

getDropdownClase(){
  let customClass = ''; 
  if(this.isDropdownDisabled()){ 
    customClass = 'disabled-dropdown'; 
  }

  return customClass;
}
  
}
